import FontFade from '../FontFade';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/csr/pc/');

export default function E(): JSX.Element {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('csr');

    const videoList = [
        {
            img: 'f-2',
            desc: t('secF_list1_desc'),
            video: 'https://www.youtube.com/embed/QVI6kyRm3zo',
        },
        {
            img: 'f-3',
            desc: t('secF_list2_desc'),
            video: 'https://www.youtube.com/embed/fbHNSN33w8w',
        },
        {
            img: 'f-4',
            desc: t('secF_list3_desc'),
            video: 'https://www.youtube.com/embed/oMAAlclPCRQ',
        },
    ];

    const [showYoutubeVideo, setShowYoutubeVideo] = useState(false);
    const [youtubeSource, setYutubeSource] = useState(videoList[0]?.video);

    const onYoutubeClick = (url: string) => {
        setShowYoutubeVideo(true);
        setYutubeSource(url);
    };

    const items = videoList.map((item: any, index: number) => (
        <div className={`f-video-item f-video-item_${index}`} key={index}>
            <div onClick={() => onYoutubeClick(item?.video)}>
                <EFPic className="f-video-img" name={[`${item.img}.webp`, `${item.img}.png`]} />
            </div>
            <div className="f-video-desc">{item.desc}</div>
        </div>
    ));

    useEffect(() => {
        const ScrollMagic = (window as any).ScrollMagic;

        const scene = new ScrollMagic.Scene({
            triggerElement: '.csr_pc_F',
            triggerHook: 1,
            offset: 500,
        }).setClassToggle('.csr_f_box', 'show');

        new ScrollMagic.Controller().addScene(scene);
    }, [showYoutubeVideo]);

    return (
        <div className={`csr_pc_F ${css.csr_pc_F}`}>
            <div className="csr_f_box">
                <div className="f-title-box">
                    <div className="csr_youtube">
                        <EFPic className="csr-f-youtube" name={['f-1.webp', 'f-1.png']} />
                    </div>
                    <div className="secF_title">
                        <FontFade offset={200}>{t('secF_title')}</FontFade>
                    </div>
                </div>
                <div className="f-video-box">
                    <div>
                        <div className="f-video-list">{items}</div>
                    </div>
                </div>
            </div>
            <EFVideoModal visible={showYoutubeVideo} source={youtubeSource} onClose={() => setShowYoutubeVideo(false)} playerType={'YouTube'} />
        </div>
    );
}
